<template>
    <v-snackbar
      v-model="enable"
      :timeout="-1"
      width="800"
      class="snackbar-style"
      light
    >
      <div
        class="snackbar-label"
        style=""
      >
        <v-card flat>
          <v-toolbar
            flat
            dense
          >
            <span>
              <a
                v-if="topic?.url"
                @click="openTopicClickEvent"
              >
              <v-icon
                small
                @click="openTopicClickEvent"
              >
                mdi-open-in-new
              </v-icon>&emsp;
                {{ topic?.content }}
              </a>
              <span v-else>{{ topic?.content }}</span>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeButtonClickEvent"  small>
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
      </div>
    </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DriverTopic',
  data() {
    return {
      enable: false,
      topic: null,
      normalizedFrequencyMinutes: 1,
      autoFetchTimer: null,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'alive'
    ]),
  },
  watch: {
    // aliveがfalse（ログアウト）になったら更新ストップ
    alive: {
      handler(newProps, oldProps) {
        if (newProps) {
          this.startTopicChecking()
        }
        if (oldProps === true && newProps === false) {
          this.stopTopicChecking()
          this.enable = false
          this.topic = null
        }
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    // ログインユーザーがいる時だけトピックを取得し、定期チェック開始
    if (this.$store.getters['DriverAuthentication/driverUser']) {
      this.show().then(topic => {
        this.topic = topic
        this.enable = !!topic
      })
    }
  },
  methods: {
    ...mapActions('DriverTopic', ['show', 'create']),

    /**
     * トピックの定期チェック開始
     */
    startTopicChecking() {
      const $this = this;
      const sec = 1000 * 60 * this.normalizedFrequencyMinutes

      this.autoFetchTimer = setInterval(() => {

        if (!$this.alive) {
          $this.stopTopicChecking();
          return
        }

        $this.show().then(topic => {
          $this.topic = topic
          $this.enable = topic ? true : false
        })
      }, sec)
    },
    // トピックの定期チェックストップ
    stopTopicChecking() {
      if (this.autoFetchTimer) {
        clearInterval(this.autoFetchTimer)
        this.autoFetchTimer = null
      }
    },

    /**
     * クローズボタン クリックイベント
     */
    closeButtonClickEvent() {
      this.create({ topic_id: this.topic.id }).then(() => {
        this.enable = false
        this.topic = null
      })
    },
    /**
     * トピッククリックイベント
     */
    openTopicClickEvent() {
      if (!this.topic?.url) return;
      window.open(this.topic.url, "_blank");
    }
  },
}
</script>

<style lang="scss">
.snackbar-style {
  z-index: 10 !important;
    & .snackbar-label {
      border-left: #0070B3; border-left-width: 5px; border-left-style: solid;width: 100%;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    & .v-snack__content {
      padding: 0 !important;
  }
}

</style>

